import { render, staticRenderFns } from "./PurchasingImportModal.vue?vue&type=template&id=d81e720a"
import script from "./PurchasingImportModal.vue?vue&type=script&lang=js"
export * from "./PurchasingImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports